import { render } from "./alarmAddress.vue?vue&type=template&id=38047f0a"
import script from "./alarmAddress.vue?vue&type=script&lang=js"
export * from "./alarmAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__